module.exports = __webpack_public_path__ + "resources/brs-credit.svg";